import { useMutation } from "@apollo/client";
import { gql } from "generated-graphql";
import { useCallback } from "react";

const ACKNOWLEDGE_UNDERSTAND_STEP = gql(`
  mutation AcknowledgeUnderstandStep($submissionId: ID!) {
    acknowledgeUnderstandStep(submissionId: $submissionId) {
      id
      acknowledgedAt
    }
  }
`);

/**
 * Stamps the current reviewer/signer's own `acknowledgedAt`. The returned id +
 * acknowledgedAt merge into the Apollo cache, so no refetch is needed.
 */
export function useAcknowledgeUnderstandStep(submissionId: string) {
  const [acknowledge, { loading }] = useMutation(ACKNOWLEDGE_UNDERSTAND_STEP);

  const acknowledgeStep = useCallback(async () => {
    await acknowledge({ variables: { submissionId } });
  }, [acknowledge, submissionId]);

  return { acknowledgeStep, loading };
}
